import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { workflowLayoutRoute } from 'src/routes';

// The workflow Memories tab: a child of the (still centrally declared)
// `/workflows/$workflowId` layout, so its real URL is
// `/workflows/$workflowId/memories`.
//
// TRANSITIONAL LOCATION — `custom/tanstack-route-file-path` cannot yet express
// a child of an unmigrated central layout: with code-based `createRoute` the
// declared path must be parent-relative (`/memories`), but the rule resolves a
// module's full path from its own declaration only (an imported parent stops
// the walk), so the file must live where `/memories` alone derives. When the
// `/workflows/$workflowId` layout migrates to
// `src/pages/authenticated/workflows/$workflowId/route.tsx`, move this module
// to `src/pages/authenticated/workflows/$workflowId/memories/index.tsx`.
export const Route = createRoute({
  getParentRoute: () => workflowLayoutRoute,
  path: '/memories',
  component: lazyRouteComponent(
    () => import('../../workflows/WorkflowMemoriesTab'),
    'WorkflowMemoriesTab',
  ),
  loader: () => ({ crumb: 'Memories' }),
});
